import type { MouseEvent } from 'react'
import { STATUS_OPTIONS, type MateriaStatus } from '../lib/status'

interface Props {
  value: string
  onChange: (value: MateriaStatus) => void
  onClick?: (e: MouseEvent) => void
}

export function StatusSelect({ value, onChange, onClick }: Props) {
  return (
    <select
      value={value}
      onClick={onClick}
      onChange={(e) => onChange(e.target.value as MateriaStatus)}
      className="status-select"
    >
      {STATUS_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
}
